module.exports = __webpack_public_path__ + "img/smap3.627c02cd.png";